import 'twin.macro'

import FileIcon from 'assets/icons/file-icon.svg?component'
import { ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

import Typography from '../Typography'

type DocumentUploadProps = {
  title: ReactNode
  titleIcon?: ReactNode
  children: ReactNode
  modalName?: string | number
  twStyle?: TwStyle
  onModalIconClick?: (name?: string | number) => void
}

const DocumentUpload = ({ titleIcon, title, children, modalName, onModalIconClick, twStyle }: DocumentUploadProps) => {
  return (
    <div css={[tw`p-5`, twStyle]}>
      <div tw='flex gap-x-2'>
        {titleIcon ? titleIcon : <FileIcon tw='flex-shrink-0' />}
        {typeof title === 'string' ? (
          <Typography variant='body' weight='bold'>
            {title}
          </Typography>
        ) : (
          title
        )}
        {/* <InfoIcon tw='flex-shrink-0 ml-auto cursor-pointer' onClick={() => onModalIconClick?.(modalName)} /> */}
      </div>
      {children}
    </div>
  )
}

export default DocumentUpload
